import _Accordion from './Accordion';

import './style/index.js';

export * from './type';

export const Accordion = _Accordion;

export default Accordion;
